import request from '@/utils/request'

export function getToken() {
  return request({
    url: '/app/findToken',
    method: 'get',
  })
}

export async function login(data) {
  return request({
    url: '/app/signIn',
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/userInfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/app/signOut',
    method: 'post',
  })
}

export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data,
  })
}
